import { render, staticRenderFns } from "./PaqReglas.vue?vue&type=template&id=7a23cc38&scoped=true"
import script from "./PaqReglas.vue?vue&type=script&lang=js"
export * from "./PaqReglas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23cc38",
  null
  
)

export default component.exports